export default __webpack_public_path__ + "static/media/product-7.357e9db9.jpg";